
import { computed, defineComponent } from 'vue'
import Header from '@/components/Header.vue'
import Footer from '@/components/Navbars/Footer.vue'
import Snackbar from '@/components/Snackbar.vue'
import useSnackbar from '@/composables/useSnackbar'
import '@/assets/styles/colors.scss'
import '@/assets/styles/typography.scss'
import '@/assets/styles/widgets.scss'
import '@/assets/styles/inputs.scss'
import '@/assets/styles/cms_content.scss'
import { version } from '../package.json'
import useTitle from '@/composables/useTitle'
import { useHead } from '@vueuse/head'
import StopSearch from '@/components/StopSearch.vue'
import { useStops } from './composables/useStops'
import { useRoute } from 'vue-router'
import { entryRouteIsNoindex } from '@/router'
export default defineComponent({
  components: { Header, Footer, Snackbar, StopSearch },
  setup () {
    const { title } = useTitle()
    // eslint-disable-next-line max-len
    const content = 'Expressway, Bus Éireann’s premium coach service, provides direct and regular services on 19 routes throughout Ireland.'
    useHead({
      meta: [
        {
          name: 'og:description',
          content: content,
          key: 'ogDescription'
        },
        {
          name: 'og:title',
          content: 'Expressway - Way Better',
          key: 'ogTitle'
        },
        {
          name: 'og:url',
          content: process.env.VUE_APP_SITE_URL,
          key: 'ogUrl'
        },
        {
          name: 'og:image',
          itemprop: 'image',
          content: `${process.env.VUE_APP_SITE_URL}images/expressway-image.jpeg`,
          key: 'ogImage'
        },
        {
          name: 'og:type',
          content: 'website',
          key: 'ogType'
        },
        {
          name: 'og:locale',
          content: 'en_IE',
          key: 'ogLocale'
        }
      ]
    })
    const route = useRoute()
    const isPrivate = computed(
      () => route.meta.noindex === true || entryRouteIsNoindex
    )
    // Keep private/transactional pages out of search indexes. These are managed
    // head tags, so they are removed again when navigating to a public page.
    useHead({
      meta: computed(() =>
        isPrivate.value
          ? [
              { name: 'robots', content: 'noindex', key: 'robots' },
              // Prerender.io only stores snapshots of pages whose status is
              // 200, so a non-200 prerender-status-code keeps these pages out
              // of its cache entirely - session and booking data is never
              // held there. Crawlers get a 404 for the URL.
              {
                name: 'prerender-status-code',
                content: '404',
                key: 'prerenderStatusCode'
              }
            ]
          : []
      )
    })

    const { loadStops } = useStops()

    loadStops()

    return {
      ...useSnackbar(),
      version,
      title
    }
  }
})
